import { Edit } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useGetPatientPreferredPharmacyQuery } from "src/api/services/patientPreferredPharmacyApi";
import { useManageModal } from "src/hooks/useManageModal";
import UpdatePreferredPharmacyModal from "../Modals/UpdatePreferredPharmacyModal";

interface Props {
  patientId: number;
}

const PatientPreferredPharmacy = ({ patientId }: Props) => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const { data } = useGetPatientPreferredPharmacyQuery(patientId);

  if (data == null) return null;

  return (
    <>
      <Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          height={34}
        >
          <Typography fontWeight={700}>Preferred Pharmacy</Typography>
          <IconButton size="small" onClick={handleOpen}>
            <Edit />
          </IconButton>
        </Stack>
        <Stack>
          <Typography>{`Pharmacy: ${data.name}`}</Typography>
          <Typography>{`Address: ${data.full_address}`}</Typography>
        </Stack>
      </Stack>
      <UpdatePreferredPharmacyModal
        onClose={handleClose}
        open={open}
        preferredPharmacy={data}
      />
    </>
  );
};

export default PatientPreferredPharmacy;
